import FolderPlus from '../src/FolderPlus';
export default FolderPlus;
